var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('h1',{staticClass:"text-h3 font-weight-light light--text text-center pt-9 pb-14"},[_vm._v("MY ACCOUNT")]),_c('change-user-password')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }